import styled from 'styled-components';

const Wrap = styled.p`
  grid-column: ${({ $fullWidth }) => ($fullWidth ? '1 / -1' : 'auto')};
  margin: 0;
  padding: ${({ $pad }) => $pad || '1rem 0'};
  color: ${({ theme }) => theme.colors.mutedForeground};
  font-size: ${({ theme }) => theme.fontClamp?.sm || '0.9375rem'};
`;

export default function PageLoading({ message = 'Loading...', fullWidth = true, style }) {
  return (
    <Wrap $fullWidth={fullWidth} style={style}>
      {message}
    </Wrap>
  );
}
